import React, {FC, useEffect, useState} from 'react';
import {MapContainer, Marker, Polyline, TileLayer, useMap} from 'react-leaflet';
import L, {LatLngTuple} from 'leaflet';
import {mapCustomIcon, mapTiles} from "../../../../mock/mapTiles";
import {ISosPosition} from "../../../../types/sos";

interface IProps {
  setSelectedLocation?: any;
  radius?: number;
  initialCenter?: LatLngTuple;
  height?: string
  locations?: ISosPosition[]
}

export const SosMap: FC<IProps> = ({setSelectedLocation, locations, radius, initialCenter, height = "500px"}) => {
  const [tile, setTile] = useState<string>(mapTiles[0].url);
  const [map, setMap] = useState<L.Map | null>(null);
  const [center, setCenter] = useState<LatLngTuple>(initialCenter! || [41.335239, 69.240373]);

  const MapEvents = () => {
    const leafletMap = useMap();

    useEffect(() => {
      setMap(leafletMap);

      const logCenterCoordinates = () => {
        if (leafletMap) {
          const newCenter = leafletMap.getCenter();
          setSelectedLocation && setSelectedLocation([newCenter.lat, newCenter.lng]);
        }
      };

      leafletMap.on('moveend', logCenterCoordinates);

      return () => {
        leafletMap.off('moveend', logCenterCoordinates);
      };
    }, [leafletMap]);

    return null;
  };

  useEffect(() => {
    if (initialCenter) {
      setCenter(initialCenter);
      centerMapTo(initialCenter[0], initialCenter[1]);
    }
  }, [initialCenter, setSelectedLocation]);

  const centerMapTo = (lat: number, lng: number) => {
    if (map) {
      map.setView([lat, lng], map.getZoom());
    }
  };

  const latestLocations = (locations || [])
      .filter(loc => !isNaN(new Date(loc.created_at).getTime()))
      .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
      .slice(0, 10);

  const polylinePositions: LatLngTuple[] = latestLocations.map((loc) => [loc.latitude, loc.longitude] as LatLngTuple);

  return (
      <div className={"position-relative"}>
        <div className={"position-absolute d-flex align-items-center gap-3"} style={{
          top: 10, right: 10, zIndex: 1000
        }}>
          <select className={"form-select w-200px"} name="" id=""
                  onChange={(e) => setTile(e.target.value)}>
            {
              mapTiles.map((tile, index) => (
                  <option key={index} value={tile.url}>{tile.name}</option>
              ))
            }
          </select>
        </div>
        <div className={"w-100 overflow-hidden d-flex justify-content-center rounded-4"}>
          <div>
            <MapContainer
                center={center as LatLngTuple}
                className={"center-of-map-selectable shadow-sm position-relative"}
                style={{height, width: "100vw"}}
                zoom={18}
                scrollWheelZoom={true}
                whenReady={() => {
                  if (initialCenter) {
                    centerMapTo(initialCenter[0], initialCenter[1]);
                  }
                }}
            >
              <TileLayer
                  url={tile}
              />
              <MapEvents/>

              <Marker position={center} icon={mapCustomIcon}/>
              <Polyline weight={5} opacity={0.7} smoothFactor={10} positions={polylinePositions} color="blue"/>
            </MapContainer>
          </div>
        </div>
      </div>
  );
};